export enum PaymentMethods {
	BANK_CARD = 'bank_card',
	SBP = 'sbp',
}

export enum TransgranPaymentMethods {
	TRANSGRAN_BANK_CARD = "transgran_bank_card",
	TRANSGRAN_SBP = "transgran_sbp"
}


export const CombinedPaymentMethods = {
	...PaymentMethods,
	...TransgranPaymentMethods
} as const;

export type CombinedPaymentMethods = typeof CombinedPaymentMethods[keyof typeof CombinedPaymentMethods];
